"use strict";
const angular = require("angular");

import _ from "underscore";
import validator from "validator";

/*@ngInject*/
export function conditionService() {
  "ngInject";

  function getBooleanValue(inputs, iname, uses) {
    let parentShowed = true;
    if (!inputs[iname]) {
      let uValue = false;
      for (let u in uses) {
        if (uses[u][iname]) {
          let parentModelId = uses[u][iname].parentModelId;
          let parent =
            uses[`input_${parentModelId}`] || inputs[`input_${parentModelId}`];
          if (parentModelId && parent) {
            parentShowed = parent.showed || false;
          }
          uValue = uValue || (uses[u][iname].value && parentShowed);
        }
      }
      return uValue;
    }

    let parentModelId = inputs[iname].parentModelId;
    let parent = inputs[`input_${parentModelId}`];
    if (parentModelId && parent) {
      parentShowed = parent.showed || false;
    }
    return (
      (inputs[iname].showed && inputs[iname].value && parentShowed) || false
    );
  }

  function getBoolean3(condObj, inputs, uses) {
    //Get operator from 1st proprety
    let op = Object.keys(condObj)[0].trim().toUpperCase();
    if (!(op === "AND" || op === "OR")) {
      new Error("Operator must be AND or OR");
      return null;
    }
    //Get content
    let cont = condObj[Object.keys(condObj)[0]];
    //Interpret object condition
    for (var c in cont) {
      if (typeof cont[c] === "object") {
        cont[c] = getBoolean3(cont[c], inputs, uses);
      }
    }
    let result = null;
    for (var c in cont) {
      if (typeof cont[c] === "string" || typeof cont[c] === "number") {
        cont[c] = getBooleanValue(inputs, `input_${cont[c]}`, uses);
      }
      if (op === "AND") {
        result = result === null ? cont[c] : result && cont[c];
      } else {
        result = result === null ? cont[c] : result || cont[c];
      }
    }
    return result;
  }

  function getBoolean4(inputs, condObj) {
    let val = inputs[`input_${condObj.input}`].value;
    let op = condObj.operator.trim();
    let comp = condObj.value;
    if (op == "==") {
      return val == comp;
    } else if (op == "==") {
      return val == comp;
    } else if (op == "!=") {
      return val != comp;
    } else if (op == ">") {
      return val > comp;
    } else if (op == ">=") {
      return val >= comp;
    } else if (op == "<") {
      return val < comp;
    } else if (op == "<=") {
      return val <= comp;
    } else {
      new Error("Incorrect syntaxe");
    }
  }
  /*
  null
  undefined
  NaN
  empty string ("")
  0
  false
  */

  function getBoolean5(inputs, condObj) {
    let val = inputs[`input_${condObj.input}`].value;
    let func = condObj.function.trim();
    let comp = condObj.value;
    if (func == "isEmpty") {
      if ((!val && val !== 0 && val !== false) || val === "[]") {
        val = "";
      } else {
        val = `${val}`;
      }
      return validator.isEmpty(val);
    } else {
      new Error("Incorrect syntaxe");
    }
  }

  return {
    getBoolean(syntaxe, generals, uses, use) {
      let inputs = use
        ? _.extend(JSON.parse(JSON.stringify(generals)), use)
        : generals;
      let synt = syntaxe.split(";");
      let type = Number.parseInt(synt[0]);
      let cond = synt[1].trim();
      if (type === 1) {
        return cond.toUpperCase() === "TRUE";
      } else if (type === 2) {
        return getBooleanValue(inputs, `input_${cond}`, uses);
      } else if (type === 3) {
        let condObj = null;
        try {
          condObj = JSON.parse(cond);
        } catch (e) {
          condObj = null;
        }
        if (condObj) {
          return getBoolean3(condObj, inputs, uses);
        } else {
          return false;
        }
      } else if (type === 4) {
        return getBoolean4(inputs, JSON.parse(cond));
      } else if (type === 5) {
        return getBoolean5(inputs, JSON.parse(cond));
      }
    },
  };
}

export default angular
  .module("dalApp.condition", [])
  .service("Condition", conditionService).name;



// WEBPACK FOOTER //
// ./client/app/permission/condition.service.js